import { BASIC_INITIAL_STATE } from '../../../utils/HttpHelper';

import getMeetStatus from './GetMeetStatus';

const MeetStatusData = { INITIAL_STATE: { ...BASIC_INITIAL_STATE }, getMeetStatus };
export default MeetStatusData;